import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { NoticeListModel } from "features/stock-ordering/core/domain/notice.model";
import {
  GetNoticesRepository,
  GetNoticesResponse,
} from "features/stock-ordering/data/stock-ordering.repository";

export enum GetNoticesState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: GetNoticesState;
  message: string;
  data: NoticeListModel | undefined;
}

const initialState: InitialState = {
  status: GetNoticesState.initial,
  message: "",
  data: undefined,
};

export const getNotices = createAsyncThunk(
  "getNotices",
  async (param: string, { rejectWithValue }) => {
    try {
      const response: GetNoticesResponse = await GetNoticesRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

export const getNoticesSlice = createSlice({
  name: "getNotices",
  initialState,
  reducers: {
    resetGetNotices: (state) => {
      state.status = GetNoticesState.initial;
      state.data = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getNotices.pending, (state) => {
        state.status = GetNoticesState.inProgress;
      })
      .addCase(getNotices.fulfilled, (state, action) => {
        if (action.payload) {
          const { message, data } = action.payload;
          state.status = GetNoticesState.success;
          state.message = message;
          state.data = data;
        }
      })
      .addCase(getNotices.rejected, (state, action) => {
        state.status = GetNoticesState.fail;
        state.message = action.payload as string;
        state.data = undefined;
      });
  },
});

export const selectGetNotices = (state: RootState) => state.getNotices;
export const { resetGetNotices } = getNoticesSlice.actions;
export default getNoticesSlice.reducer;
